import React from "react";
import "./FaqView.scss";
import {Tabs} from "antd";
import {TabPosition} from "rc-tabs/lib/interface";
import {TabsType} from "antd/lib/tabs";
import {getTranslate, Translate, TranslateFunction} from "react-localize-redux";
import {connect} from "react-redux";
import StoreState from "../../interfaces/store/storeState";
import FaqList from "../../components/FaqList/FaqList";
import {
    clearFaqList, getFaqList, searchFaq, setActiveFaqType,
} from "../../store/actions/faq";
import {
    ClearFaqListAction, GetFaqListAction, SearchFaqAction, SetActiveFaqTypeAction,
} from "../../interfaces/store/actions/faq";
import {Faq} from "../../interfaces/store/actions/payload/faq";
import {FaqTypeAll} from "../../utils/constants";

const {TabPane} = Tabs;

interface StateProps {
    translate: TranslateFunction
    activeFaqType: string
    isMobile: boolean
    list: Faq[]
}

interface DispatchProps {
    setActiveFaqType(payload: string): SetActiveFaqTypeAction

    getFaqList(): GetFaqListAction

    clearFaqList() : ClearFaqListAction

    searchFaq(payload: string) : SearchFaqAction
}

type Props = StateProps & DispatchProps;

class FaqView extends React.Component<Props> {
    private static readonly translationPath: string = "pages.FaqView.FaqView";

    constructor(props: Props) {
        super(props);

        this.onChangeHandler = this.onChangeHandler.bind(this);

        this.getTabPanes = this.getTabPanes.bind(this);
    }

    componentDidMount(): void {
        this.props.getFaqList();
    }

    componentWillUnmount(): void {
        this.props.setActiveFaqType(FaqTypeAll);
        this.props.clearFaqList();
    }

    /**
     * On tab change event, set store's current active faq type
     * @param {string} currentTabType
     */
    onChangeHandler(currentTabType: string): void {
        this.props.setActiveFaqType(currentTabType);
        this.props.searchFaq("");
    }

    /**
     * Generate tab panes for all faq question and for each category separately that exists
     * @return {React.ReactNode}
     */
    getTabPanes(): React.ReactNode {
        const {
            activeFaqType, isMobile, list,
        }: Props = this.props;
        const availableFaqTypes: string[] = [];

        if (list.length) {
            availableFaqTypes.push(FaqTypeAll);
            list.forEach((faq: Faq) => {
                const {Category}: Faq = faq;
                if (Category && !availableFaqTypes.includes(Category.trim())) {
                    availableFaqTypes.push(Category.trim());
                }
            });
        }

        return availableFaqTypes.map((availableFaqType: string) => {
            const tabKey: string = availableFaqType.replace(/\s/g, "-");
            return (
                <TabPane
                    tab={availableFaqType}
                    key={tabKey}
                >
                    {activeFaqType === tabKey && (
                        <FaqList isMobile={isMobile} key={tabKey}/>
                    )}
                </TabPane>
            );
        });
    }

    render(): React.ReactNode {
        const {isMobile, translate}: Props = this.props;
        const tabPosition: TabPosition = isMobile ? "top" : "left";
        const tabType: TabsType = isMobile ? "line" : "card";
        return (
            <div className="df-faqs-container">
                <Tabs
                    tabPosition={tabPosition}
                    type={tabType}
                    onChange={this.onChangeHandler}
                    moreIcon={(
                        <span aria-label={translate(`${FaqView.translationPath}.moreTabs.text`) as string}>
                            <Translate id={`${FaqView.translationPath}.moreTabsContent.text`}/>
                        </span>
                    )}
                >
                    {this.getTabPanes()}
                </Tabs>
            </div>
        );
    }
}

function mapStateToProps(state: StoreState): StateProps {
    return {
        translate: getTranslate(state.localize),
        activeFaqType: state.faq.activeFaqType,
        isMobile: state.mobile.isMobile,
        list: state.faq.list,
    };
}

const mapDispatchToProps: DispatchProps = {
    setActiveFaqType,
    getFaqList,
    clearFaqList,
    searchFaq,
};

export default connect(mapStateToProps, mapDispatchToProps)(FaqView);
